import { useEffect, useState } from "react"
import { Modal } from "react-bootstrap"
import constants from "../../constants/constants"
import { ErrorToast, InfoToast } from "../../shared"
import btnClose from "../../assets/images/svg/close_modal_icon.svg";
// import { Trash } from "../../assets/images/svg/trash";
import { Trash } from "../../assets/images/svg/icon"
import { postCustomer } from "../../api/requestAxios/accounting";


const OutputCustomer = ({
    setOutputCustomer
}) => {

    const [loading, setLoading] = useState(false)
    const [show, setShow] = useState(false)
    const [image, setImage] = useState({ preview: "", raw: "" });
    const [success, setSuccess] = useState(false)

    useEffect(() => {
        setShow(true)
        // postCustomer()

    }, [])


    useEffect(() => {
        if (success) {
            InfoToast('لیست مشترکین در حال دانلود می‌باشد')
        }

    }, [success])


    const postCustomerFn = async (e) => {
        // e.preventDefault()
        let failed = false
        try {
            setLoading(true)
            const services = await postCustomer(image.raw)
            // const url = window.URL.createObjectURL(new Blob([services.data]));
            // const link = document.createElement('a');
            // link.href = url;
            // link.setAttribute('download', `${Date.now()}.xlsx`);
            // document.body.appendChild(link);
            // link.click();
            // failed=false
            // setOutputCustomer(false)
            if (services?.data?.Success !==undefined && !services?.data?.Success) {
                failed=true
                ErrorToast(services?.data?.Message )

            }
            else if (services.data) {
                var mediaType = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,";
                var a = document.createElement('a');
                a.href = mediaType + services.data;
                a.download = `${Date.now()}.xlsx`;
                a.textContent = 'Download file!';
                document.body.appendChild(a);
                a.click()
                document.body.removeChild(a);
                setOutputCustomer(false)
            }
            setLoading(false)
        }
        catch {
            failed = true
            setLoading(false)
            ErrorToast(constants.ServerErroe)
            setOutputCustomer(false)
        }
        setSuccess(!failed)
    }

    const handleClose = () => {
        setShow(false)
        setOutputCustomer(false)
    }
    const handleChangeImage = e => {
        if (e.target.files.length) {
            if (e.target.files[0].size <= 15728640) {
                setImage({
                    preview: URL.createObjectURL(e.target.files[0]),
                    raw: e.target.files[0],
                    name: e.target.files[0].name
                });
            }
            else {
                setImage({
                    preview: '',
                    raw: '',
                    name: ''
                });
                ErrorToast('حجم فایل انتخاب شده بیشتر از 15 مگابایت است')
            }
        }


    };
    const remove = () => {
        setImage({
            preview: '',
            raw: '',
            name: ''
        });
    }
    return (
        <Modal show={show} animation={true} dir="rtl" className="accounting-modal" >
            <Modal.Header>
                <Modal.Title className="d-flex justify-content-between w-100" style={{ fontSize: '16px' }}>
                    آپلود لسیت مشترک‌های قبلی
                    <img
                        alt=""
                        onClick={handleClose}
                        src={btnClose}
                        className="btn-close-modal"
                    />
                </Modal.Title>
            </Modal.Header>
            <Modal.Body >
                <div className="accounting-list ">
                    {!image.preview &&
                        <>
                            <label className="accounting-modal-content-view d-flex flex-row justify-content-center align-items-center" htmlFor="downloadCusomer">جستجوی فایل</label>
                            <input
                                type="file"
                                id="downloadCusomer"
                                style={{ display: 'none' }}
                                onChange={handleChangeImage}
                                onClick={(event) => {
                                    event.currentTarget.value = null
                                }}
                                accept='.xlsx' />
                        </>

                    }
                    {image.preview &&
                        <div className="accounting-modal-content-view d-flex flex-row justify-content-between">
                            <span onClick={(e) => { remove(e) }}><Trash /></span>
                            <span>{image.name}</span>
                        </div>
                    }
                </div>

            </Modal.Body>
            {<Modal.Footer className="d-flex flex-row justify-content-center accounting-modal-footer-view accounting-list">
                <button className="btn btn-primary btn-custom" onClick={(e) => { postCustomerFn(e) }}>
                    {loading ? <div className="spinner-border" role="status" aria-hidden="true"></div> : ' آپلود و دریافت لیست جدید'}

                </button>
            </Modal.Footer>}

        </Modal>
    )
}
export default OutputCustomer